import {Text} from '@primer/react-brand/esm'

import Styles from './Label.module.css'

type Props = {
  text: string
}

export function Label(props: Props) {
  const {text} = props

  return (
    <div className={Styles.LabelWrapper}>
      <Text className={Styles.Label} as="div">
        {text}
      </Text>
    </div>
  )
}
